import * as React from 'react'

const PasswordFingerprintIcon = (props) => (
  <svg width={217} height={143} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={108.722} cy={78.106} r={64.032} fill="#F0F0F0" />
    <circle cx={40.831} cy={37.529} r={6.291} fill="#F0F0F0" />
    <circle cx={179.563} cy={52.317} r={4.827} fill="#F0F0F0" />
    <circle cx={48.88} cy={124.265} r={3.571} fill="#F0F0F0" />
    <circle cx={194.159} cy={40.992} r={3.571} fill="#F0F0F0" />
    <circle cx={168.565} cy={118.182} r={3.571} fill="#F0F0F0" />
    <circle cx={32.871} cy={109.783} r={4.827} fill="#F0F0F0" />
    <circle cx={176.297} cy={32.396} r={5.975} fill="#F0F0F0" />
    <circle cx={108.722} cy={78.105} r={53.759} fill="#E6E6E6" />
    <circle cx={108.722} cy={78.106} r={40.076} fill="#D0D0D0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.844 94.945H162.6l10.387 7.783H44.458l10.386-7.783Z"
      fill="#707070"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.844 26.197a2 2 0 0 0-2 2v66.748H162.6V28.197a2 2 0 0 0-2-2H56.844Zm116.143 76.531H44.458v1.891a2 2 0 0 0 2 2h124.529a2 2 0 0 0 2-2v-1.891Z"
      fill="#545454"
    />
    <path fill="#DFDFDF" d="M58.739 30.737h99.966v59.668H58.739zM97.687 98.836h22.07v2.594h-22.07z" />
    <rect x={10.278} y={42.735} width={20.003} height={20.003} rx={6} stroke="#757575" strokeWidth={4} />
    <rect x={0.894} y={53.929} width={37.505} height={30.004} rx={4} fill="#D0D0D0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.447 70.357a4.502 4.502 0 1 0-3.6 0v3.975a1.8 1.8 0 0 0 3.6 0v-3.975Z"
      fill="#757575"
    />
    <path d="M63.041 6.973a6 6 0 0 1 6-6h79.362a6 6 0 0 1 6 6v15.76H63.041V6.973Z" fill="#AEAEAE" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.759 7.85c0 1.32-1.074 2.39-2.4 2.39-1.324 0-2.399-1.07-2.399-2.39s1.075-2.39 2.4-2.39 2.399 1.07 2.399 2.39Zm7.798 0c0 1.32-1.074 2.39-2.4 2.39-1.324 0-2.398-1.07-2.398-2.39s1.074-2.39 2.399-2.39 2.399 1.07 2.399 2.39Zm5.4 2.39c1.324 0 2.398-1.07 2.398-2.39s-1.074-2.39-2.399-2.39-2.399 1.07-2.399 2.39 1.074 2.39 2.4 2.39Z"
      fill="#fff"
    />
    <path d="M63.041 14.237h91.362V75.01a6 6 0 0 1-6 6H69.041a6 6 0 0 1-6-6V14.237Z" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.474 55.014a1 1 0 0 1 1-1h58.496a1 1 0 0 1 1 1v2.258a1 1 0 0 1-1 1H79.474a1 1 0 0 1-1-1v-2.258ZM78.474 62.11a1 1 0 0 1 1-1h58.496a1 1 0 0 1 1 1v2.258a1 1 0 0 1-1 1H79.474a1 1 0 0 1-1-1V62.11Z"
      fill="#DFDFDF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.474 69.207a1 1 0 0 1 1-1h58.496a1 1 0 0 1 1 1v2.258a1 1 0 0 1-1 1H79.474a1 1 0 0 1-1-1v-2.258Z"
      fill="gray"
    />
    <path
      d="M98.995 27.456a11.67 11.67 0 0 0-1.751 8.832M114.047 23.55a11.655 11.655 0 0 0-7.641-1.051 11.655 11.655 0 0 0-5.716 2.954M120.195 31.66a11.662 11.662 0 0 0-4.02-6.712M120.432 34.21c.016-.84-.058-1.693-.231-2.55M97.25 36.287c.034.168.071.335.112.5M105.697 45.286a13.157 13.157 0 0 0 3.025-11.312"
      stroke="#757575"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.093 45.676c2.37-3.463 3.445-8.422 2.499-12.28-.429-1.777-1.864-2.618-3.452-2.297-1.588.32-2.607 1.793-2.287 3.453.707 3.66-.542 7.173-3.052 9.522M103.114 36.1a7.333 7.333 0 0 1-2.674 6.151"
      stroke="#757575"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M114.775 35.035a19.18 19.18 0 0 0-.314-2.218h.001a5.858 5.858 0 0 0-11.575.602M112.919 44.903a18.983 18.983 0 0 0 1.889-7.206"
      stroke="#757575"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M106.039 25.61a8.783 8.783 0 0 0-5.928 10.1h.004a4.399 4.399 0 0 1-1.472 4.229M117.03 42.22c.842-3.16.99-6.558.3-9.981h-.002a8.785 8.785 0 0 0-8.606-7.049"
      stroke="#757575"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M202.577 94.27s-14.829-2.936-8.411-25.887c18.303 14.957 8.411 25.886 8.411 25.886Z"
      fill="#AEAEAE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M200.347 93.973s-4.601-10.602 12.657-16.797c-1.466 18.13-12.657 16.797-12.657 16.797Z"
      fill="#DFDFDF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M196.879 94.234s-11.554.293-10.833-18.029c16.262 8.152 10.833 18.029 10.833 18.029Z"
      fill="#707070"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M187.336 91.77h21.523c.719 0 1.301.586 1.301 1.309v.364c0 .588-.297 1.136-.788 1.455l-.935.607v4.194c0 2.274-.631 4.502-1.822 6.435l-.054.088a6.024 6.024 0 0 1-5.127 2.869h-6.672a6.025 6.025 0 0 1-5.128-2.869l-.053-.088a12.26 12.26 0 0 1-1.823-6.435v-4.194l-.934-.607a1.734 1.734 0 0 1-.789-1.455v-.364c0-.723.583-1.308 1.301-1.308Z"
      fill="#DFDFDF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M208.304 95.482h-13.367l-.86 1.856h14.227v-1.856Z"
      fill="#000"
      fillOpacity={0.2}
    />
    <circle cx={36.505} cy={85.26} r={12.374} fill="#007F26" />
    <path d="m34.384 90.917-5.304-5.304 1.768-1.767 3.536 3.535 7.778-7.778 1.768 1.768-9.546 9.546Z" fill="#fff" />
  </svg>
)

export default PasswordFingerprintIcon
